import React from 'react';
import styles from './DesignEditorPin.module.css'
import {Col, Row} from "react-bootstrap";
import Pin from "./Pin/Pin";
import PinParameters from "./Pin/PinParameters";

const DesignEditorPin = () => (
    <Row className={styles.editor}>
        <Col lg={8} className={styles.canvas}>
            <Pin/>
        </Col>
        <Col lg={4} className={styles.parameters}>
            <PinParameters/>
        </Col>
    </Row>
);

export default DesignEditorPin;
